export class StoreModel {
    static getStoreListWithIdAndName(storeList: StoreModel[]):StoreModel[] {
        return storeList.map((s) => {
            let name = `${s.idSource} - ${s.name}`

            if (!s.isActive) {
                name += ` (INATIVO)`
            }

            return {
                ...s,
                name,
            }
        })
    }

    id?: number = undefined;
    idSource?: string = undefined;
    idExternal?: string = undefined;
    name: string = "";
    isActive: boolean = true;

    constructor(s?:Partial<StoreModel>) {
        Object.assign(this, s)
    }
}
